/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authstartcantcontinueheading4Inputs */

const en_authstartcantcontinueheading4 = /** @type {(inputs: Authstartcantcontinueheading4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't continue`)
};

const pt_authstartcantcontinueheading4 = /** @type {(inputs: Authstartcantcontinueheading4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível continuar`)
};

/**
* | output |
* | --- |
* | "Couldn't continue" |
*
* @param {Authstartcantcontinueheading4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authstartcantcontinueheading4 = /** @type {((inputs?: Authstartcantcontinueheading4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authstartcantcontinueheading4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authstartcantcontinueheading4(inputs)
	return pt_authstartcantcontinueheading4(inputs)
});
export { authstartcantcontinueheading4 as "authStartCantContinueHeading" }